




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation, namespace } from 'vuex-class';

@Component({})
export default class StepForm3 extends Vue {

  @Prop({ type: Object, default: () => {} })
  private value!: any;

  private data: any = {};

  constructor() {
    super();
  }

  private onFinish() {
    this.data.step = 0;
  }

  private mounted(): void {
    this.data = this.value;
  }

}
